import React, { useEffect, useState } from "react";
import "./CompanyProfilePopup.scss";
import {
  deleteicon,
  deleteiconcircle,
  downloadFileIcon,
  downloadFileIconV2,
  downloadIcon,
  editIconBlue,
  lockIcon,
  modalCloseIcon,
  pdfIcon,
  pdfImagePreview,
  trashIconCircleOrange,
  uploadIcon,
  uploadIconBlack,
} from "../../../../../images";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import config from "../../../../../config/config";
import BusinessFileUpload from "../../../../../components/BusinessFileUpload/BusinessFileUpload";
import style from "../../../../../pages/FormFiveLightTheme/Form/formfivelighttheme.module.scss";
// import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
// import DeleteConfirmProfilePopup from "../DeleteConfirmProfileUploads/DeleteConfirmProfilePopup";
import http from "../../../../../helpers/http";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import BusinessFileUploadEdit from "../../../../../components/BusinessFileUploadEdit/BusinessFileUploadEdit";
import { toast } from "react-toastify";
import ToastMsg from "../../../../../components/ToastMsg/ToastMsg";
import helper from "../../../../../helpers/helper";
import { useWindowSize } from "react-use";
import useTheme from "../../../../../components/useTheme/useTheme";

const CompanyProfilePopup = (props) => {
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const [upload, setUpload] = useState(false);
  const objectUrl = config.aws_object_url + "business/";
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [pdfImage, setPdfImage] = useState(true);
  const [selectedDoc, setSelectedDoc] = useState();
  const handleShowDeletePopupOpen = (item, prefixName) => {
    const updatedFile = { ...item, prefixName };
    setSelectedDoc(updatedFile);
    setShowDeletePopup(true);
  };
  const handleShowDeletePopupClose = () => setShowDeletePopup(false);
  const galleryTitles = [
    { key: "project_renders_media", title: "Project Photos & Renders" },
    { key: "completed_products_media", title: "Products | Materials" },
    { key: "sites_inprogress_media", title: "Sites In Progress" },
    { key: "others_media", title: "Others" },
  ];

  const {
    show,
    onHide,
    handleClose,
    categoryData,
    editIcon = false,
    isActive = 0,
    isSubtabActive = 0,
    updateCompanyProfileData,
  } = props;

  const BusinessContext = useBusinessContext();
  const TOTAL_STORAGE =
    BusinessContext?.data?.subscription?.plan?.features?.imagesLimit || 200;

  const totalImages = galleryTitles.reduce((sum, { key }) => {
    return sum + (BusinessContext?.data[key]?.length || 0);
  }, 0);

  const isDeleteDisabled = totalImages >= TOTAL_STORAGE;
  const handleDeleteDocument = async (documentId) => {
    if (isDeleteDisabled) {
      // toast(
      //   <ToastMsg
      //     message={`Cannot delete documents. Storage limit of ${TOTAL_STORAGE} images reached.`}
      //     danger={true}
      //   />,
      // );
      return;
    }
    const response = await http.put(
      `${config.api_url}/business/business-details/${categoryData?.userId}/documents`,
      { documentId }
    );
    if (response?.data) {
      const updatedData = categoryData.data.filter(
        (doc) => doc._id !== documentId
      );
      categoryData.data = updatedData;
      BusinessContext.update({
        ...BusinessContext.data,
        [categoryData.category.key]: updatedData,
      });
      updateCompanyProfileData({
        ...BusinessContext.data,
        [categoryData?.category?.key]: updatedData,
      });
      toast(
        <ToastMsg message={`Document deleted successfully`} />,
        config.success_toast_config
      );

      handleShowDeletePopupClose();
    }
  };

  const handleFileUpload = async (
    uploadedFileData,
    state,
    documentMediaType
  ) => {
    const updatedData = await BusinessContext.fetchData(
      BusinessContext?.data?._id
    );
    categoryData.data = updatedData[documentMediaType];
    BusinessContext.update(updatedData);
    updateCompanyProfileData(updatedData);
  };

  return (
    <>
      {/* <DeleteConfirmProfilePopup
        show={showDeletePopup}
        handleClose={handleShowDeletePopupClose}
        selectedDoc={selectedDoc}
        onDelete={handleDeleteDocument}
      /> */}
      <Modal
        {...props}
        centered
        className={`CompanyProfile_popup_modal company_profile_edit_page zIndex_company_profile ${
          theme === "dark" && "CompanyProfile_popup_modal_edit--dark-mode"
        }`}
        backdropClassName="custom-backdrop"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button className="custom-cancel-btn" onClick={props.handleClose}>
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className={`comp_prof_container`}>
            <div className="CompanyProfile_popup_container">
              <div className="comp_prof_wrapper CompanyProfile_popup_wrapper">
                <div className="cta_container">
                  <h2 className="title">{categoryData?.title}</h2>
                  {editIcon && (
                    <div className="cta_wrapper">
                      <img
                        src={editIconBlue}
                        alt="edit icon"
                        className="edit_icon"
                      />
                      <Link to={() => false} className="bedit_common_cta">
                        Edit
                      </Link>
                    </div>
                  )}
                </div>

                <div className="row pofile_row CompanyProfile_popup_row">
                  {categoryData?.data?.map((item, index) => (
                    <div
                      className="pofile_col CompanyProfile_popup_col"
                      key={item._id || `pdf-${index}`}
                    >
                      {item?.thumbnail ? (
                        <a
                          href={`${objectUrl}${item?.url}`}
                          target="_blank"
                          rel="noreferrer"
                          download={item?.name}
                        >
                          <div className="profile_box">
                            <div className="img_wrapper CompanyProfile_popup_img_wrapper CompanyProfile_popup_img_wrapper_img_prev position-relative">
                              {/* <img
                              src={downloadFileIcon}
                              alt="pdf icon"
                              className="pdf_icon"
                            /> */}
                              {item?.thumbnail ? (
                                <img
                                  src={`${objectUrl}${item.thumbnail}`}
                                  alt="pdf-image"
                                  className="pdf_img_prev_edit"
                                />
                              ) : (
                                <img
                                  src={downloadFileIcon}
                                  alt="pdf icon"
                                  className={`pdf_icon`}
                                />
                              )}
                              <img
                                src={lockIcon}
                                alt="lock"
                                className="lock_pdf_icon_modal"
                              />
                              <div className="wraper_pdf_name_tarsh">
                                <h3 className="pdf_title">
                                  {/* {helper.truncateFileName(item.name)} */}
                                  {`${helper.getBusinessNamePrefix(
                                    `${categoryData?.image_prefix}_${String(
                                      Number(index) + 1
                                    ).padStart(2, "0")}_` +
                                      BusinessContext?.data?.business_name,
                                    item.url,
                                    width >= 1200 ? 25 : 20
                                  )}`}
                                </h3>
                                <img
                                  src={downloadFileIconV2}
                                  alt="download icon"
                                  className="download_icon delete_icon_pdf del_ic_prc_img mt-0 space_crt" 
                                  onClick={() =>
                                    handleShowDeletePopupOpen(
                                      item,
                                      `${categoryData?.image_prefix}_${String(
                                        Number(index) + 1
                                      ).padStart(
                                        2,
                                        "0"
                                      )}_${helper.getBusinessNamePrefix(
                                        BusinessContext?.data?.business_name,
                                        item.url
                                      )}`
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </a>
                      ) : (
                        <div className="profile_box">
                          <div className="img_wrapper CompanyProfile_popup_img_wrapper position-relative">
                            <img
                              src={downloadFileIcon}
                              alt="pdf icon"
                              className="pdf_icon"
                            />
                            <img
                              src={lockIcon}
                              alt="lock"
                              className="lock_pdf_icon_modal"
                            />
                            <img
                              src={downloadFileIconV2}
                              alt="download icon"
                              className="download_icon delete_icon_pdf"
                              onClick={() =>
                                window.open(
                                  `${objectUrl}${item?.url}`,
                                  "_blank"
                                )
                              }
                            />
                          </div>
                          <h3 className="pdf_title">
                            {/* {helper.truncateFileName(item.name)} */}
                            {`${helper.getBusinessNamePrefix(
                              `${categoryData?.category?.image_prefix}_${String(
                                Number(index) + 1
                              ).padStart(2, "0")}_` +
                                BusinessContext?.data?.business_name,
                              item.url,
                              width >= 1200 ? 25 : 20
                            )}`}
                          </h3>
                        </div>
                      )}
                    </div>
                  ))}
                  {/* <div
                    className="pofile_col CompanyProfile_popup_col"
                  
                  >
                    <div className="file_upload_file_container">
                      <div className={`field_wrapper`}>
                        <div
                          className={style.customdUpload_wrapper}
                          style={{ height: "100%" }}
                        >
                          <BusinessFileUploadEdit
                            businessContext={BusinessContext.data}
                            onFileUpload={(files, state) =>
                              handleFileUpload(
                                files,
                                state,
                                categoryData?.category?.key
                              )
                            }
                            documentMediaType={categoryData?.category?.key}
                            Upload_heading={`Upload More ${categoryData?.category?.fileUploadTitle}`}
                            uploadIcon={uploadIconBlack}
                            fileSize={
                              BusinessContext?.data?.subscription?.plan
                                ?.features?.fileSizeLimitMB || 150
                            }
                          />
                      
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>

    // <Modal
    //   show={show}
    //   onHide={onHide}
    //   centered
    //   className="CompanyProfile_popup_modal company_profile_edit_page"
    //   backdropClassName="custom-backdrop"
    //   fullscreen={true}
    // >
    //   <Modal.Header>
    //     <button className="custom-cancel-btn" onClick={handleClose}>
    //       <img
    //         src={modalCloseIcon}
    //         alt="close-icon"
    //         className="ctm_img_bussine_edit_about"
    //       />
    //     </button>
    //   </Modal.Header>

    //   <Modal.Body>
    //     <div className={`comp_prof_container`}>
    //       <div className="CompanyProfile_popup_container">
    //         <div className="comp_prof_wrapper CompanyProfile_popup_wrapper">
    //           <div className="cta_container">
    //             <h2 className="title">Firm/Company Profile</h2>
    //             {editIcon && (
    //               <div className="cta_wrapper">
    //                 <img
    //                   src={editIconBlue}
    //                   alt="edit icon"
    //                   className="edit_icon"
    //                 />
    //                 <Link to={() => false} className="bedit_common_cta">
    //                   Edit
    //                 </Link>
    //               </div>
    //             )}
    //           </div>

    //           <div className="row pofile_row CompanyProfile_popup_row">
    //             {/* {CompanyProfilePopupData?.data?.map((item, index) => ( */}
    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={downloadIcon}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={deleteiconcircle}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={deleteiconcircle}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="profile_box">
    //                 <div className="img_wrapper CompanyProfile_popup_img_wrapper">
    //                   <img
    //                     src={downloadFileIcon}
    //                     alt="pdf icon"
    //                     className="pdf_icon"
    //                   />
    //                   <img
    //                     src={deleteiconcircle}
    //                     alt="download icon"
    //                     className="download_icon delete_icon_pdf"
    //                   />
    //                 </div>
    //                 <h3 className="pdf_title">
    //                   Loremipsum Set Dolor Dummy Text.PDF
    //                 </h3>
    //               </div>
    //             </div>

    //             <div
    //               className="pofile_col CompanyProfile_popup_col"
    //               // key={item._id || `pdf-${index}`}
    //             >
    //               <div className="file_upload_file_container">
    //                 <div className={`field_wrapper`}>
    //                   <div
    //                     className={style.customdUpload_wrapper}
    //                     style={{ height: "100%" }}
    //                   >
    //                     <BusinessFileUpload
    //                       businessContext={upload}
    //                       //   onFileUpload={handleFileUpload}
    //                       documentMediaType={"company_profile_media"}
    //                       formatSupport=""
    //                       fileSize=" "
    //                       fileFormat=" "
    //                       Upload_heading="Upload More Product Catalogues"
    //                       uploadIcon={uploadIconBlack}
    //                     />
    //                     {/* <p className={style.error}>{error}</p> */}
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>

    //             {/* ) */}
    //             {/* )} */}
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </Modal.Body>
    // </Modal>
  );
};

export default CompanyProfilePopup;
